import React from 'react';
import gql from 'graphql-tag';
import {FieldConfigurationFragment} from '../../../scenes/app/formConfiguration/fragments';
import Tip, {TipType} from '../../../ui/Tip';
import SimpleFieldForm, {SimpleFieldFormProps} from './SimpleFieldForm';

export default function PercentRatingForm({
  sectionId, defaultLanguage, configuration, onCreateUpdate,
}: SimpleFieldFormProps) {
  const tip = (
    <Tip type={TipType.Info} className="mb-3">
      Attendees select an answer from a predefined set of options (10%, 20%, ...). This type fits best for questions
      like &quot;How likely are you to recommend us...?&quot;
    </Tip>
  );

  return (
    <SimpleFieldForm sectionId={sectionId} configuration={configuration} defaultLanguage={defaultLanguage}
      onCreateUpdate={onCreateUpdate} createMutation={createMutation} updateMutation={updateMutation}
      tip={tip}/>
  );
}

const createMutation = gql`
  mutation CreateMutation($type: FormType!, $data: PercentRatingInput!) {
    field: createPercentRatingField(type: $type, data: $data) {
      ...CompleteFieldConfiguration
    }
  }
  ${FieldConfigurationFragment}
`;

const updateMutation = gql`
  mutation UpdateMutation($id: ID!, $type: FormType!, $data: PercentRatingInput!) {
    field: updatePercentRatingField(id: $id, type: $type, data: $data) {
      ...CompleteFieldConfiguration
    }
  }
  ${FieldConfigurationFragment}
`;
